var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"col":"12"}},[(!_vm.$route.params.id)?_c('h2',[_vm._v("CREAR EXAMEN")]):_c('h2',[_vm._v("EDITAR EXAMEN")]),_c('CRUDEventProcessCreate',{attrs:{"storeModel":_vm.storeModel,"storeModelGroup":_vm.storeModelGroup,"defaultDate":_vm.defaultDate}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }